module.exports = __webpack_public_path__ + "img/fallbackprovider.213a2b90.png";